/**
 * Route for `campaign-read-endpoint`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignReadEndpointPage } from "../features/campaign-read-endpoint/CampaignReadEndpointPage";

export const campaignReadEndpointRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-read-endpoint",
	component: CampaignReadEndpointPage,
});

export default campaignReadEndpointRoute;
